import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/AuthContext";
const UserRoute = ({ children }) => {
  const { user } = useAuth();
  const membershipPaid = JSON.parse(localStorage?.getItem('membershipPaid'))
  // Check if the user is authenticated and has the "admin" role
  if (!user || !membershipPaid) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default UserRoute;
